import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { isMobile } from "react-device-detect";

import Counter from "../../components/counter/Counter";

const StyledTitleBlock = styled.div.attrs({
  className: "u-wrapper u-relative",
})`
  margin-top: ${isMobile ? "19.1dvh" : "38.2dvh"};
  width: 100%;
`;

const StyledTitle = styled.h2.attrs({
  className: "heading-spacing-2140 u-pb16 u-mb4",
})`
  margin-left: ${isMobile ? "52px" : "68px"};

  @keyframes gradientAnimation {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 100% 50%;
    }
  }

  background: linear-gradient(
    90deg,
    pink,
    hotpink,
    red,
    orange,
    yellow,
    springgreen,
    turquoise,
    deepskyblue,
    dodgerblue,
    violet
  );
  background-size: ${isMobile ? "200% auto" : "200% auto"};
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: gradientAnimation 21s linear infinite;
`;

const OsTitleBlock = ({ number, title }) => {
  return (
    <StyledTitleBlock>
      <Counter number={number} type="os" />
      <StyledTitle>{title}</StyledTitle>
    </StyledTitleBlock>
  );
};

OsTitleBlock.propTypes = {
  number: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default OsTitleBlock;
